/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { PHDocumentController } from "document-model";
import { AppModule } from "../module.js";
import type { AppModuleAction, AppModulePHState } from "./types.js";

export const AppModuleController = PHDocumentController.forDocumentModel<
  AppModulePHState,
  AppModuleAction
>(AppModule);
